import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  requestsTableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    '& .agGridDeviceMainTableRowSelected': {
      backgroundColor: theme.vars.palette.transparent.a5
    },
    '& .ag-grid-device-main-table-row-selected': {
      backgroundColor: theme.vars.palette.transparent.a5
    },
    '& .ag-row': {
      fontSize: '0.875rem'
    },
    '& .ag-header': {
      fontSize: '0.875rem'
    }
  },
  searchBar: {
    padding: '.5rem 1rem',
    backgroundColor: theme.vars.palette.background.elevation1
  },
  routeButtonTooltipArrow: {
    color: theme.vars.palette.background.navigation
  },
  routeButtonTooltip: {
    backgroundColor: theme.vars.palette.background.navigation,
    fontSize: '0.875rem',
    padding: theme.spacing(1)
  },
  deviceStatusIconStyle: {
    marginRight: theme.spacing(1)
  },
  icoLabelStyle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  icoLabelHeaderStyle: {
    alignContent: 'center',
    display: 'flex'
  },
  warningColor: {
    color: theme.vars.palette.warning.main
  },
  chipMarginGap: {
    marginRight: theme.spacing(0.5)
  },
  ellipsisMenu: {
    minWidth: '200px'
  },
  dialogContainer: {
    backgroundColor: theme.vars.palette.transparent.a25,
    'MuiDialog-container': {
      backgroundColor: theme.vars.palette.background.elevation1
    }
  },
  statusCodeBox: {
    borderRadius: '0.5rem 0.5rem 0 0',
    padding: '0.5rem 0.5rem 0 0.5rem',
    maxWidth: 'max-content'
  },

  timeDescriptionBox: {
    borderRadius: '0 0.5rem 0.5rem 0.5rem',
    padding: '0.5rem'
  },
  collapseTableParent: {},
  collapseTableParentSelected: {
    border: `1px solid ${theme.vars.palette.primary.main}`,
    backgroundColor: theme.vars.palette.transparent.a5,
    td: {
      borderBottom: `0rem solid`
    },
    '& MuiTableCell-root': {
      borderTop: `0rem solid`
    }
  },
  collapseTableInnerWrapper: {
    td: {
      borderBottom: `0rem solid`
    }
  },
  collapseTableHasGrandChild: {
    '&:before': {
      height: '2.4rem!important'
    }
  },
  collapseTableHasNoGrandChild: {},
  collapseTableGrandChildInnerWrapper: {
    '&:before': {
      height: '0rem!important'
    },
    td: {
      borderBottom: `0rem solid`
    }
  },
  collapseTableInner: {
    backgroundColor: theme.vars.palette.background.elevation1,
    borderBottom: '1px solid var(--mui-palette-TableCell-border)',
    '& tr th': {
      borderBottom: '0rem'
    },
    '& tr:before': {
      height: '4.75rem',
      content: '""',
      position: 'relative',
      left: '3.75rem',
      top: '0rem',
      width: '0.13rem',
      bottom: '0rem',
      display: 'flex',
      borderLeft: '0.125rem dashed',
      opacity: '.3',
      transition: 'height 0.3s ease-in-out'
    },
    '& tr:last-child:before': {
      height: '2.4rem'
    },
    '& tr.GrandChild.haveChild:nth-last-of-type(2):before': {
      height: '2.4rem'
    },
    '& tr.GrandChildExpands:before': {
      height: '2.4rem',
      transition: 'height 0.3s ease-in-out'
    },
    '& tr.collapseTableGrandChildInnerWrapper:before': {
      height: '0rem',
      transition: 'height 0.3s ease-in-out'
    }
  },
  collapseTableInnerRow: {},
  collapseTableInnerRowSelected: {
    backgroundColor: theme.vars.palette.transparent.a10,
    border: `1px solid ${theme.vars.palette.primary.main}`
  },
  tableGroup: {
    backgroundColor: theme.vars.palette.transparent.a10
  },
  iconCollapse: {
    cursor: 'pointer',
    width: '1.375rem',
    fontSize: '1.125rem',
    alignSelf: 'center'
  },
  subDataRow: {
    '&:before': {
      height: '0.125rem',
      content: '""',
      position: 'relative',
      left: '0.125rem',
      top: '1.25rem',
      width: '1.25rem',
      bottom: '0rem',
      borderBottom: '0.125rem dashed',
      opacity: '.3'
    },
    '&:first-of-type': {
      paddingLeft: '2.5rem'
    }
  },
  dFlex: {
    display: 'flex'
  },
  alignSelfCenter: {
    alignSelf: 'center'
  },
  deviceDetailCardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0.5rem 1rem',
    display: 'flex'
  },
  deviceDetailCommon: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`
  },
  deviceDetailParentcard: {
    height: '100%',
    margin: '.75rem 0',
    '&:last-child': {
      marginBottom: '3.125rem'
    }
  },
  deviceDetailCard: {
    backgroundColor: theme.vars.palette.background.elevation0,
    padding: '.75rem'
  },
  deviceDetailCardContent: {
    display: 'flex',
    marginBottom: '0.6 rem',
    '&:last-child': {
      marginBottom: '0rem'
    }
  },
  deviceChartArea: {
    backgroundColor: theme.vars.palette.background.elevation1
  },

  deviceMainTable: {
    height: '100%',
    '& th': {
      padding: '0.5rem 1rem',
      backgroundColor: theme.vars.palette.background.elevation2
    }
  },

  deviceHeaderSeperator: {
    borderBottom: '1px solid var(--mui-palette-TableCell-border)'
  },

  card: {
    height: '100%'
  },
  cardContent: {
    height: '100%',
    padding: '0 !important'
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0.5rem 1rem'
  },
  tableHeaderSticky: {
    position: 'sticky',
    top: '0',
    backgroundColor: theme.vars.palette.background.elevation2,
    borderBottom: `1px solid ${theme.vars.palette.background.elevation0}`,
    zIndex: '99'
  },
  rowGroup: {
    margin: theme.spacing(0)
  },
  headerFunctionStrip: {
    backgroundColor: theme.vars.palette.transparent.a5,
    borderRadius: '.25rem'
  },
  deviceTableContainer: {
    height: '100%',
    minHeight: 500,
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation2,
    gridRow: 'span 4',
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    },
    '& td': {
      paddingBottom: '.8rem',
      paddingTop: '.8rem'
    },
    // in production
    '& td:first-of-type': {
      width: 'auto'
    },
    '& .ag-row-level-0': {
      backgroundColor: theme.vars.palette.transparent.a10
    },
    '& .ag-root-wrapper': {
      borderRadius: '.25rem'
    },
    '& .agGridDeviceTableRowSelected': {
      backgroundColor: theme.palette.action.selected,
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    '& .ag-grid-device-main-table-row-selected': {
      backgroundColor: theme.palette.action.selected,
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    '& .ag-group-expanded, & .ag-group-contracted': {
      display: 'none !important'
    },
    '& .ag-group-child-count': {
      display: 'none !important'
    }
  },
  deviceDetailsCard: {
    height: '100%',
    minHeight: 500,
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation1,
    gridRow: 'span 4',
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    }
  },
  devicesTablePagination: {
    backgroundColor: theme.vars.palette.background.elevation2,
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    bottom: 0,
    display: 'relative',
    position: 'sticky',
    zIndex: 29
  },
  successColor: {
    color: theme.vars.palette.success.main
  },
  disabledColor: {
    color: theme.vars.palette.secondary.main
  },
  errorColor: {
    color: theme.vars.palette.error.main
  },
  sourceErrorMessage: {
    padding: '.5rem',
    height: '5.5rem',
    overflow: 'scroll',
    borderRadius: theme.shape.borderRadius,
    borderWidth: '1px 1px 1px 1px',
    borderStyle: 'solid',
    borderColor: theme.vars.palette.border.main
  },
  KVFlex: {
    display: 'flex',
    margin: '0.625rem 0',
    gap: '.5rem'
  },
  flexLeftCol: {
    flex: 0.4
  },
  flexRightCol: {
    flex: 0.6,
    inlineSize: '10.625rem',
    wordWrap: 'break-word'
  },
  searchbar: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1)
  },
  cell1w: {
    width: '28%'
  },
  cell1w_a: {
    width: 'auto'
  },
  cell1w_b: {
    width: 'auto'
  },
  cell2w_a: {
    width: '15%'
  },
  cell2w_b: {
    width: 'auto'
  },
  cell3w: {
    width: '12%'
  },
  cell3w_a: {
    width: '15%'
  },
  cell3w_b: {
    width: '12%'
  },
  cell4w: {
    width: '8%'
  },
  cell4w_a: {
    width: '10%'
  },
  cell4w_b: {
    width: '8%'
  },
  cell5w: {
    width: '10%'
  },
  cell5w_a: {
    width: '10%'
  },
  cell5w_b: {
    width: '10%'
  },
  cell6w_a: {
    width: '0%'
  },
  cell6w_b: {
    width: '16%'
  },
  cell7w_a: {
    width: '7%'
  },
  cell7w_b: {
    width: '8%'
  },
  cell8w: {
    width: '3%'
  },
  cell9w: {
    width: '3%'
  },
  statusInfoAccordion: {
    backgroundColor: theme.vars.palette.background.elevation1,
    margin: '0.5rem 0 0.5rem 0'
  },
  statusInfoAccordionDetails: {
    backgroundColor: theme.vars.palette.background.elevation2
  },
  searchbarInput: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
    borderWidth: '1px 0 1px 1px',
    borderStyle: 'solid',
    borderColor: theme.vars.palette.border.main,
    padding: theme.spacing(0, 0.5),
    gap: theme.spacing(0.5),
    overflow: 'hidden',
    '& input': {
      border: 0,
      outline: 'none',
      flex: 1,
      background: theme.vars.palette.transparent.a0,
      width: '100%',
      color: theme.vars.palette.text.primary,
      position: 'absolute',
      left: 0,
      right: 0,
      fontSize: '0.875rem'
    }
  },
  searchbarInputContainer: {
    [theme.breakpoints.down('lg')]: {
      width: '100%'
    },
    [theme.breakpoints.down('xxl')]: {
      searchbarInputContainerminWidth: '20vw'
    },
    display: 'flex',
    minWidth: '33vw'
  },
  searchbarSearchBtn: {
    borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
    backgroundColor: theme.vars.palette.transparent.a10,
    padding: theme.spacing(0.5, 1)
  },
  searchbarFilterChip: {
    maxWidth: '15rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  textInputWrapper: {
    flex: 1,
    minWidth: '2rem',
    position: 'relative',
    height: '1.25rem',
    display: 'flex',
    alignItems: 'center'
  },
  cloudSourceCard: {
    backgroundColor: theme.vars.palette.background.elevation0,
    padding: '.75rem',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.vars.palette.transparent.a10
    }
  },
  devicesTableHeaderCell: {
    padding: '0 !important'
  },
  ellipsisIcoBtn: {
    float: 'inline-end',
    marginRight: '.5rem'
  },
  cardContentMicrosoft: {
    height: '100%',
    padding: '0',
    paddingBottom: '3rem',
    '&:last-child': {
      paddingBottom: '3rem'
    }
  },
  statusInfoAccordionMicrosoft: {
    backgroundColor: theme.vars.palette.background.elevation1,
    margin: '0.5rem 0 0.5rem 0',
    padding: '1rem'
  },
  cldcell1: {
    width: '25%'
  },
  cldcell2: {
    width: '20%'
  },
  cldcell3: {
    width: '10%'
  },
  cldcell4: {
    width: '5%'
  }
}));

export default useStyles;
